<template lang="pug">
  v-row.user-record-course
    v-col(cols=12)
      h1 Анкета обучающегося
    v-col(cols=12 sm=12 md=10 lg=8 xl=6)
      div
        .mb-4
          v-alert(
            v-if="!canContinue"
            type="error"
            text
          ) Для продолжения обучения на данном курсе пожалуйста заполните форму зачисления
          v-alert(
            v-else-if="step === 2"
            type="success"
          ) Спасибо за уделенное время. Теперь вы можете продолжить обучение
          //- v-btn(
          //-   depressed
          //-   @click="step = 1"
          //- ) вернуться к редактированию
        v-scroll-y-transition(leave-absolute)
          v-skeleton-loader(
            v-if="loading.init"
            type="list-item@6"
          )
        template(v-if="!loading.init")
          attributes-form(
            v-if="step === 1 && attributes.length"
            :attributes="attributes"
            :method="saveAttrs"
            :course="course"
            has-privacy-agreement
          )
          v-scroll-x-transition(leave-absolute)
            sign-enrollment-docs(
              v-if="step === 2"
              :statements="signStatements"
              :loading-statements="loading.statements"
              @uploaded="assignStatement"
            )
        v-btn(
          v-if="canContinue && course"
          color="secondary"
          rounded
          depressed
          large
          :to=`{
            name: 'EducationCourseUnitList',
            params: { courseId: course.id },
          }`
        ) Продолжить обучение
</template>

<script>
import AttributesForm from '@/components/Forms/AttributesForm.vue';

import SignEnrollmentDocs from '../components/SignEnrollmentDocs.vue';

export default {
  components: {
    AttributesForm,
    SignEnrollmentDocs,
  },
  data: () => ({
    file: null,

    course: null,
    enrollment: null,
    attributes: [],
    signStatements: [],
    loading: {
      init: true,
      statements: false,
    },

    step: 1,
  }),
  computed: {
    canContinue() {
      return this.step === 2 && this.allSigned && !this.loading.statements;
    },
    allSigned() {
      return this.signStatements.every((i) => i.scan_file_url);
    },
  },
  async created() {
    this.loading.init = true;
    await this.fetchCourse();
    await this.fetchCourseRecord();
    this.loading.init = false;
  },
  methods: {
    async fetchCourse() {
      const { item } = await this.$api.courses.show(this.$route.params.courseId, {
        expand: 'organization,priority_user_prior_record',
      });
      this.course = item;
    },
    async fetchSignStatements() {
      this.loading.statements = true;
      this.step += 1;
      const { items } = await this.$api.enrollments.userSignStatements(
        this.enrollment.id,
      );
      this.signStatements = this.enrollment.is_enrollment_scan_required
        ? items : items.filter(({ type }) => type !== 1);
      this.loading.statements = false;
    },
    async fetchCourseRecord() {
      const { items } = await this.$api.enrollments.coursePriorRecords(
        this.$route.params.courseId,
        { expand: 'statements', 'search[id]': this.course.priority_user_prior_record.id },
      );
      [this.enrollment] = items;

      const { items: attributes } = await this.$api.enrollments
        .coursePriorRecordAttributes(this.course.priority_user_prior_record.id);
      this.attributes = attributes;
      if (attributes.every((i) => i.value)) {
        this.fetchSignStatements();
      }
    },
    async saveAttrs({ attributes, obs }) {
      await this.$api.enrollments.attributesSave(this.enrollment.id, attributes, obs);
      this.fetchSignStatements();
    },
    assignStatement({ statement, file }) {
      this.$api.enrollments.userSaveStatement(
        this.enrollment.id, statement.id, { file_name: file.file_name },
      );
      const statament = this.signStatements.find((i) => i.id === statement.id);
      this.$set(statament, 'scan_file_url', file.url);
    },
  },
};
</script>
